export const COLORS = {
  primary: "#ffffff",
  secondary: "#472183",
  green: "#03AC0E",
  hover_green: "rgb(14 159 110)",
};
